import { useState } from "react";
import { AdminSidebar } from "./admin/AdminSidebar";

export function AdminLayout({
  title,
  subtitle = "營運後台",
  children,
  actions
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="admin-app-shell">
      <AdminSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} onToggle={() => setSidebarOpen((value) => !value)} />
      <main className="admin-shell">
        <header className="admin-topbar">
          <div>
            <span className="admin-kicker">龍來喬後台</span>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
          {actions ? <div className="admin-topbar-actions">{actions}</div> : null}
        </header>
        <div className="admin-content">{children}</div>
      </main>
    </div>
  );
}
